import {Meter, MeterEntity} from "../../../model/meter";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type MeterSelectorProps = {
    regionId?: string
    showDoNotUse?: boolean;
};

const getRegionIdParam = createParamSelector<MeterSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getShowDoNotUseParam = createParamSelector<MeterSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse);

export const metersSelector = () => createSelector(
    [getUseQueryResultData<Meter[]>, getRegionIdParam, getShowDoNotUseParam],
    (data, regionId, showDoNotUse) => {
        return selectMetersAndTransform(
            data ?? [], {
                regionId: regionId,
                showDoNotUse: showDoNotUse
            }
        );
    }
);

export const meterSelector = () => createSelector(
    [getUseQueryResultData<Meter>],
    (data) => {
        return data ? transformMeter(data) : undefined;
    }
);

export const selectMeters = (values?: Meter[], selector?: MeterSelectorProps): Meter[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;

        if (selector?.regionId) {
            if (v.regionId !== selector.regionId) {
                filterIn = false;
            }
        }

        const showDoNotUse = selector?.showDoNotUse ?? false;
        if (filterIn && !showDoNotUse && v.doNotUse) {
            filterIn = false;
        }

        return filterIn;
    });
};

export const transformMeter = (value: Meter): MeterEntity => {
    return MeterEntity.from(value)
}

export const selectMetersAndTransform = (values?: Meter[], selector?: MeterSelectorProps): MeterEntity[] => {
    const selected = selectMeters(values, selector);
    return selected.map(transformMeter);
};
